import React, { FC } from 'react';

export const SvgSpinnerIcon: FC = ({ ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <mask
            id="b"
            width={6}
            height={7}
            x={15}
            y={5}
            maskUnits="userSpaceOnUse"
            style={{
                maskType: 'alpha',
            }}
        >
            <path fill="url(#a)" d="M21 12a8.984 8.984 0 0 0-3.211-6.892l-1.93 2.297A5.984 5.984 0 0 1 18 12h3Z" />
        </mask>
        <g mask="url(#b)">
            <path fill="#FF0032" d="M1.5 1.5h21v21h-21z" />
        </g>
        <mask
            id="d"
            width={9}
            height={9}
            x={12}
            y={12}
            maskUnits="userSpaceOnUse"
            style={{
                maskType: 'alpha',
            }}
        >
            <path fill="url(#c)" d="M12 18v3a9 9 0 0 0 9-9h-3a6 6 0 0 1-6 6Z" />
        </mask>
        <g mask="url(#d)">
            <path fill="#FF0032" d="M1.5 1.5h21v21h-21z" />
        </g>
        <mask
            id="f"
            width={9}
            height={9}
            x={3}
            y={12}
            maskUnits="userSpaceOnUse"
            style={{
                maskType: 'alpha',
            }}
        >
            <path fill="url(#e)" d="M6 12H3a9 9 0 0 0 9 9v-3a6 6 0 0 1-6-6Z" />
        </mask>
        <g mask="url(#f)">
            <path fill="#FF0032" d="M1.5 1.5h21v21h-21z" />
        </g>
        <mask
            id="h"
            width={11}
            height={9}
            x={3}
            y={3}
            maskUnits="userSpaceOnUse"
            style={{
                maskType: 'alpha',
            }}
        >
            <path fill="url(#g)" d="M6 12H3a9 9 0 0 1 9-9 1.5 1.5 0 0 1 0 3 6 6 0 0 0-6 6Z" />
        </mask>
        <g mask="url(#h)">
            <path fill="#FF0032" d="M1.5 1.5h21V21h-21z" />
        </g>
        <defs>
            <linearGradient id="a" x1={18} x2={15.094} y1={12} y2={7.441} gradientUnits="userSpaceOnUse">
                <stop stopOpacity={0.08} />
                <stop offset={1} stopOpacity={0} />
            </linearGradient>
            <linearGradient id="c" x1={12} x2={18} y1={18} y2={12} gradientUnits="userSpaceOnUse">
                <stop stopOpacity={0.35} />
                <stop offset={1} stopOpacity={0.08} />
            </linearGradient>
            <linearGradient id="e" x1={6} x2={12} y1={12} y2={18} gradientUnits="userSpaceOnUse">
                <stop stopOpacity={0.65} />
                <stop offset={1} stopOpacity={0.35} />
            </linearGradient>
            <linearGradient id="g" x1={13.5} x2={5.867} y1={6} y2={11.826} gradientUnits="userSpaceOnUse">
                <stop />
                <stop offset={1} stopOpacity={0.65} />
            </linearGradient>
        </defs>
    </svg>
);
